import {
  LitElement,
  html
} from 'lit';

import { classMap } from 'lit/directives/class-map.js';
import FigureCaptionStyle from './style.js';
import LdsIcon from '../LdsIcon/index.js';
export class LdsFigureCaption extends LitElement {
  static get styles() {
    return FigureCaptionStyle;
  }

  static properties = {
    buttonCloseText: { type: String },
    buttonOpenText: { type: String },
    figcaptionId: { type: String },
    iconClosedLabel: { type: String },
    iconOpenLabel: { type: String },
    isOpen: { type: Boolean },
    maxHeight: { type: String },
    maxHeightOverRide: { type: String },
  };

  constructor() {
    super();
    this.buttonCloseText = 'View description';
    this.buttonOpenText = 'Hide description';
    this.figcaptionId = 'defaultId';
    this.iconClosedLabel = 'Expand icon';
    this.iconOpenLabel = 'Collapse icon';
    this.isOpen = false;
    this.maxHeight = undefined;
    this.maxHeightOverRide = undefined;
  }

  handleToggle() {
    this.isOpen = !this.isOpen;
    this.setAccordionOpenHeight();
  }

  setAccordionOpenHeight() {
    if (!this.figcaptionId) {
      // eslint-disable-next-line
      console.error(dedent`
        LdsAccordionToggle - Error
        Prop 'figcaptionId' must be set for accordion to function correctly.
      `);
    }
    const toggle = document.getElementById(this.figcaptionId);
    const captionPanel = toggle.querySelector(`#${this.figcaptionId} .lds-figure-caption-accordion-panel`);
    const caption = toggle.querySelector(`#${this.figcaptionId} .lds-figure-caption-accordion-body`);

    /* Check the value of maxHeight prob and apply respective height to caption body */
    if (this.isOpen) {
      if (this.maxHeight) {
        let heightVar;
        switch (this.maxHeight) {
        case 'small':
          heightVar = 'var(--lds-spacing-figure-caption-accordion-size-small)';
          caption.style.maxHeight = heightVar;
          captionPanel.style.maxHeight = this.setAccordionDynamicHeight(heightVar);
          break;
        case 'medium':
          heightVar = 'var(--lds-spacing-figure-caption-accordion-size-medium)';
          caption.style.maxHeight = heightVar;
          captionPanel.style.maxHeight = this.setAccordionDynamicHeight(heightVar);
          break;
        case 'large':
          heightVar = 'var(--lds-spacing-figure-caption-accordion-size-large)';
          caption.style.maxHeight = heightVar;
          captionPanel.style.maxHeight = this.setAccordionDynamicHeight(heightVar);
          break;
        default:
          break;
        }
      } else if (this.maxHeightOverRide) {
        let heightVar = `${this.maxHeightOverRide}px`;
        caption.style.maxHeight = heightVar;
        captionPanel.style.maxHeight = this.setAccordionDynamicHeight(heightVar);
      } else {
        caption.style.maxHeight = `${caption.scrollHeight}px`;
        captionPanel.style.maxHeight = `${caption.scrollHeight}px`;
      }
    } else {
      caption.style.maxHeight = 0;
    }
  }

  /* This  method return the height for child div, which returns value as total height - (top padding + bottom padding) */
  // eslint-disable-next-line class-methods-use-this
  setAccordionDynamicHeight(heightVar) {
    let dynamicHeight = `calc(${heightVar} - calc(var(--lds-spacing-figure-caption-accordion-padding-top) + var(--lds-spacing-figure-caption-accordion-padding-bottom)))`;
    return dynamicHeight;
  }

  render() {
    return html`
      <button class="toggle-btn ${classMap({ noCollapse: this.nocollapse })}"
      @click=${this.handleToggle}
      aria-expanded=${this.isOpen}>
        <lds-icon
          label="${this.isOpen ? this.iconOpenLabel : this.iconClosedLabel}"
          class="lds-figure-caption-toggle-icon ${classMap({ open: this.isOpen, disabledIcon: this.disabled })}"
          name="CaretDownFill">
        </lds-icon>
        ${this.isOpen ? this.buttonOpenText : this.buttonCloseText}
      </button>
    `;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-figure-caption-toggle')) window.customElements.define('lds-figure-caption-toggle', LdsFigureCaption);
  LdsIcon.defineComponent();
}

export default { LdsFigureCaption, defineComponent };
